import {Injectable} from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import {AppService} from './app.service';
import { Observable, of } from 'rxjs';
import { switchMap, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class PrintDataResolver  {
    constructor(private _appService: AppService) {
  }

    resolve(route: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<any> {
        const type = route.queryParams['type'];
        // prefer route param (for primary /:urlId/print), then query param
        const urlId = route.params['urlId'] || route.queryParams['urlId'] || route.parent?.params['urlId'];

        // If we don't have the calculation loaded in AppService, fetch it first so calls like
        // getDatasetChoiceId() used by PrintPageComponent don't throw.
        const currentCalculation = this._appService.getCalculation();
        const currentUrlId = currentCalculation ? currentCalculation.urlId : null;

        if (urlId && (!currentUrlId || currentUrlId !== urlId)) {
            return this._appService.fetchCalculationByUrlIdWithReqNavProps(urlId)
                .pipe(
                    switchMap(() => this._appService.fetchPrintData(type, urlId)),
                    catchError(() => {
                        // even if fetching the calculation fails, still try to fetch print data
                        return this._appService.fetchPrintData(type, urlId);
                    })
                );
        }

        return this._appService.fetchPrintData(type, urlId);
  }
}
